var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{staticClass:"uploading-image",attrs:{"src":_vm.image}}),_c('input',{attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.upload}})])}
var staticRenderFns = []

export { render, staticRenderFns }